import Translator from '@utils/i18n/Translator/Translator';

const initialLang = document.documentElement.getAttribute('lang');
const translator = new Translator(I18N_CONFIG, initialLang);

export default translator;
